import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function Success() {
  return (
    <>
      <Helmet>
        <title>Sororin - Κατάστημα Ομορφιάς</title>
        <meta name="description" content="Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας. Ανακαλύψτε την πολυτελή συλλογή μας από προϊόντα περιποίησης και ομορφιάς." />
      </Helmet>

      <div className="success-container">
      <FaStar className="success-icon" />
      <h1>Επιτυχής Παραγγελία!</h1>
      <p>
        Ευχαριστούμε για την παραγγελία σας! Η παραγγελία σας έχει καταχωρηθεί επιτυχώς 
        και θα την επεξεργαστούμε το συντομότερο δυνατό.
      </p>
      <p>
        Θα λάβετε ένα email επιβεβαίωσης με όλες τις λεπτομέρειες της παραγγελίας σας 
        στην διεύθυνση που μας δώσατε.
      </p>
      <p>
        Η ομάδα μας θα επικοινωνήσει μαζί σας σύντομα για να επιβεβαιώσει την αποστολή 
        και να σας ενημερώσει για τον εκτιμώμενο χρόνο παράδοσης.
      </p>
      <div className="product-actions" style={{ marginTop: '2rem' }}>
        <Link to="/" className="btn btn-primary">
          Επιστροφή στην Αρχική
        </Link>
        <Link to="/contact" className="btn btn-secondary">
          Επικοινωνήστε μαζί μας
        </Link>
      </div>
    </div>
  
    </>);
}

export default Success;